import React from 'react';
import { CtaButton } from './CtaButton';
import { CourtBackdrop } from './CourtBackdrop';
import { ProductStack } from './ProductStack';
import { coaches } from '../data/coaches';
import { PRODUCT_MOCKUP, PRODUCT_MOCKUP_ALT } from '../data/product';
const chips = ['6 Volumes', '5 Bonuses', '136 Session Cards', 'The Four-Block Session', 'Level Ladder on every drill', 'Rotation Grid · 2 to 16+'];
const micro = ['Instant PDF download', '7-day money-back guarantee', 'Print the card, run the session'];

/**
 * Proof line under the CTA. Swap for a real rating + buyer count
 * once you have verified reviews.
 */
const PROOF_LINE = <>
    Built for <span className="font-bold text-white" data-id="element-129" data-mp="sd47ys528qjq">rec, club &amp; community pickleball coaches</span>{' '}
    in the US, UK, Canada &amp; Australia
  </>;
export function Hero() {
  return <section className="relative w-full overflow-hidden bg-navy-deep" data-id="element-130" data-mp="3czfme2gnud7m">
      <CourtBackdrop className="pointer-events-none absolute inset-0 h-full w-full" data-id="element-131" data-mp="381nrczkpyaz7" />
      <div className="pointer-events-none absolute inset-0 bg-gradient-to-r from-navy-deep via-navy-deep/85 to-navy-deep/40" aria-hidden="true" data-id="element-132" data-mp="3j9kc5f0exnhp" />
      <div className="relative mx-auto w-full max-w-6xl px-4 pb-12 pt-5 sm:px-5 sm:pb-16 lg:pb-20 lg:pt-10" data-id="element-133" data-mp="39al9qe68qo35">
        <div className="grid gap-7 lg:grid-cols-[1.02fr_.98fr] lg:items-center lg:gap-14" data-id="element-134" data-mp="3e8wj6nsmiwku">
          <div className="lg:col-start-1 lg:row-start-1" data-id="element-135" data-mp="30iawsp3yo4i7">
            <p className="text-[10px] font-bold uppercase tracking-[1.6px] text-gold sm:text-[11px]" data-id="element-136" data-mp="30gq1uydqijjt">
              Court Ready · The Four-Block Session System for pickleball coaches
            </p>
            <h1 className="mt-2.5 font-display text-[34px] font-bold uppercase leading-[.94] tracking-tight text-white sm:text-5xl lg:text-6xl xl:text-7xl" data-id="element-137" data-mp="2qlod43ndfjhr">
              Every player moving.{' '}
              <span className="mark-slash" data-id="element-138" data-mp="2hjymv1586qlk">
                <span data-id="element-139" data-mp="2lla6mq1f4hlu">No one in line.</span>
              </span>
            </h1>
          </div>

          <div className="lg:col-start-2 lg:row-span-2 lg:row-start-1 lg:self-center" data-id="element-140" data-mp="s2jmpvqkdyiz">
            {PRODUCT_MOCKUP ? <img src={PRODUCT_MOCKUP} alt={PRODUCT_MOCKUP_ALT} width={2048} height={1360} className="mx-auto w-full max-w-[580px] rounded-2xl border border-navy-line object-cover shadow-card lg:max-w-none" data-id="element-141" data-mp="naa0oqsklilz" /> : <ProductStack className="mx-auto w-full max-w-[560px]" data-id="element-142" data-mp="1b0du65c1o1z9" />}
          </div>

          <div className="lg:col-start-1 lg:row-start-2" data-id="element-143" data-mp="162c95ev25sl5">
            <p className="max-w-xl text-[15px] leading-relaxed text-white/75 sm:text-base lg:text-lg" data-id="element-144" data-mp="1126mye7k4yag">
              A full year of pickleball lessons, clinics and drills, already
              planned — 136 Session Cards, each one a complete session built in
              four blocks: Warm-Up Rally, Skill, Situation and Live Play. The
              Level Ladder puts beginner, intermediate and rec players on the
              same court, and the Rotation Grid keeps everyone hitting, from 2
              players to 16+. Pick up the card and run it.
            </p>

            <ul className="mt-5 flex flex-wrap gap-1.5 sm:gap-2" data-id="element-145" data-mp="218k0693f759p">
              {chips.map(chip => <li key={chip} className="rounded-full border border-navy-line bg-navy-deep/60 px-2.5 py-1 text-[10px] font-bold uppercase tracking-wide text-white/70 sm:px-3 sm:py-1.5 sm:text-[11px]" data-id="element-146" data-mp="2b0pnv6mn30j3">
                  {chip}
                </li>)}
            </ul>

            <div className="mt-7 w-full max-w-md lg:mx-0" data-id="element-147" data-mp="2p1jylvx5tdkx">
              <CtaButton href="#pricing" data-id="element-148" data-mp="2tzlfqbb0z2tr">Get Court Ready</CtaButton>
            </div>

            <div className="mt-5 flex flex-col gap-3 sm:flex-row sm:items-center sm:gap-4" data-id="element-149" data-mp="2txhbfs97s1sy">
              <ul className="flex -space-x-2.5" data-id="element-150" data-mp="uokdjna0fr69">
                {coaches.map((coach, i) => <li key={`${coach.name}-${i}`} data-id="element-151" data-mp="znn6488t04xc" data-mpi={i}>
                    <img src={coach.avatar} alt={coach.name} width={40} height={40} loading="lazy" className="h-9 w-9 rounded-full border-2 border-navy-deep object-cover sm:h-10 sm:w-10" data-id="element-152" data-mp="4al0z9wrz4l9" />
                  </li>)}
              </ul>
              <p className="max-w-sm text-xs leading-relaxed text-white/65" data-id="element-153" data-mp="3hphc0f9gn3w1">
                {PROOF_LINE}
              </p>
            </div>

            <ul className="mt-5 grid gap-2 text-xs text-white/60 sm:flex sm:flex-wrap sm:gap-x-5" data-id="element-154" data-mp="3ct0mphqiyjhd">
              {micro.map(item => <li key={item} className="flex items-center gap-2" data-id="element-155" data-mp="3mpn6e37474ht">
                  <span className="h-1.5 w-1.5 flex-none rounded-full bg-gold" data-id="element-156" data-mp="3mnag92r7dnto" />
                  {item}
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}